// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Exam_Loading__2IQ2o","Notification":"Exam_Notification__z_l7f","NotificationWrapper":"Exam_NotificationWrapper__gHAjQ"};